import { render, staticRenderFns } from "./NoRealTaskListPage.vue?vue&type=template&id=d67d0c1e&"
import script from "./NoRealTaskListPage.vue?vue&type=script&lang=js&"
export * from "./NoRealTaskListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports